import React, { useState, useContext } from "react"

// s4n
import { injectIntl } from "gatsby-plugin-intl"
import ReactPaginate from 'react-paginate' // @see: https://github.com/AdeleD/react-paginate
import ContextProductIndex from './../../../s4n/context/ProductIndex'
import { DisplayFormikState } from "./../../../components/forms/formikHelper"



const ComponentStateless = (props) => {
    const { intl } = props;
    const t = intl.formatMessage;
    
    const contextProductIndex = useContext(ContextProductIndex);

    const [state, setState] = useState({
        currentPage: 0,
    });

    // @see: https://github.com/AdeleD/react-paginate/blob/master/demo/js/demo.js
    const onPageChange = data => {
        const filters = {...contextProductIndex.filters};
        const limit = filters.limit;
        const { selected: currentPage } = data;

        setState({
            currentPage: currentPage,
        });
        // setState((prevState, props) => ({
        //     ...prevState,
        //     currentPage: currentPage,
        // }));

        contextProductIndex.updateFilters({
            offset: Math.ceil(currentPage * limit),
        });
    };

    const resultsCount = contextProductIndex.data.queryResult.data.commerceProductQuery.count;
    const pageCount = Math.ceil(resultsCount / contextProductIndex.filters.limit);

    // @see: https://github.com/AdeleD/react-paginate/blob/master/demo/js/demo.js
    return (
        <React.Fragment>
            {/* {!contextProductIndex.data.loading && contextProductIndex.data.queryResult &&  */}

                {/* <DisplayFormikState {...{
                    pageCount: pageCount, 
                    currentPage: state.currentPage,
                }} /> */}
                {/* <DisplayFormikState {...state} /> */}

                <ReactPaginate
                    // onPageChange={onPageChange} // internal
                    onPageChange={props.onPageChange}
                    
                    // @see: https://github.com/AdeleD/react-paginate/issues/262, to override selected page with parent prop
                    // forcePage={state.currentPage} // internal
                    forcePage={props.currentPage}

                    pageCount={pageCount}
                    previousLabel={ t({ id: "soft4net_pagination_prev" }) }
                    nextLabel={ t({ id: "soft4net_pagination_next" }) }
                    breakLabel={`...`}
                    breakClassName={`page-item break-me`}
                    breakLinkClassName={`page-link`}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
            
                    containerClassName={'pagination pagination-circle pg-blue mb-0 dynamic'} // The classname of the pagination container.
                    subContainerClassName={'pages pagination'}
                    previousClassName={`page-item _disabled clearfix d-none d-md-block`} // The classname on tag li of the previous button.
                    nextClassName={`page-item _disabled clearfix d-none d-md-block`} // The classname on tag li of the next button.
                    pageClassName={`page-item`} // The classname on tag li of each page element.
                    previousLinkClassName={`page-link`} // The classname on tag a of the previous button.
                    nextLinkClassName={`page-link`} // The classname on tag a of the next button.
                    pageLinkClassName={`page-link`} // The classname on tag a of each page element.
                    activeClassName={`active`} // The classname for the active page.
                />
            {/* } */}
        </React.Fragment>
    )
}

export default injectIntl(ComponentStateless)